module.exports = __webpack_public_path__ + "static/media/vhs.e94ba7cc.svg";